import React from 'react'
import { useTranslation } from 'react-i18next'
import { haptic } from '../../utils/fx'
import './LanguageToggle.scss'

const LANGUAGES = ['ro', 'ru'] as const

const c = 'language-toggle'

const LanguageToggle = ({ variant = 'light' }: { variant?: 'light' | 'soft' }) => {
  const { i18n } = useTranslation()
  const active = i18n.language === 'ru' ? 1 : 0

  const change = (language: string) => {
    if (language === i18n.language) return
    haptic()
    i18n.changeLanguage(language)
    localStorage.setItem('language', language)
  }

  return (
    <div
      className={`${c} ${c}--${variant}`}
      role='radiogroup'
      aria-label='language'
    >
      <span
        className={`${c}__thumb`}
        style={{ transform: `translateX(${active * 100}%)` }}
      />
      {LANGUAGES.map((language) => (
        <button
          key={language}
          type='button'
          role='radio'
          aria-checked={i18n.language === language}
          className={`${c}__option${i18n.language === language ? ' is-active' : ''}`}
          onClick={() => change(language)}
        >
          {language.toUpperCase()}
        </button>
      ))}
    </div>
  )
}

export default LanguageToggle
